/** NG */
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

/** DGX */
import { SharedUiComponentsCoreModule } from '@domgen/dgx-fe-components-core';
import {
  FooterModule,
  HeaderModule,
} from '@domgen/dgx-ui-whitelabel-components';

/** Common */
import {
  ApplianceDetailsQueryParamsFormDataProvider,
  ApplianceDetailsStoreFeatureConfigFormDataProvider,
} from '@common/data-access-appliance-details';
import {
  QueryParamsEffects,
  QueryParamsPartialState,
  queryParamsReducer,
  QUERY_PARAMS_KEY,
  RestartJourneyEffects,
} from '@common/data-access-shared';
import {
  AppProvidersConfig,
  AppProvidersConfigToken,
  CommonFeatureCoreModule,
  META_REDUCERS,
} from '@common/feature-core';
import {
  ApplianceDetailsUiModule,
  CommonUiSalesComponentsModule,
} from '@common/ui-sales-components';
import {
  APPLIANCE_DETAILS_FORM_DATA_PROVIDER,
  ENVIRONMENT,
} from '@common/util-foundation';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { environment } from '@hoover/util-environment';
import { SharedDataAccessNavigationModule } from '@shared/data-access-navigation';
import { HooverAppComponent } from './components/hoover-app.component';
import { HooverFeatureShellRoutingModule } from './hoover-feature-shell-router.module';
import { NAVIGATION_RULES } from './modules/navigation-rules.config';
import { ErrorComponent } from './components/error/error.component';

const modules = [
  HooverFeatureShellRoutingModule,
  CommonUiSalesComponentsModule,
  HttpClientModule,
  SharedUiComponentsCoreModule,
  HeaderModule,
  FooterModule,
];

@NgModule({
  declarations: [HooverAppComponent, ErrorComponent],
  imports: [
    ...modules,
    CommonModule,
    StoreModule.forRoot(
      {
        [QUERY_PARAMS_KEY]: queryParamsReducer,
      } as ActionReducerMap<QueryParamsPartialState & Record<string, unknown>>,
      {
        metaReducers: [...META_REDUCERS],
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }
    ),
    SharedDataAccessNavigationModule.forRoot({
      defaultRedirectUrl: environment.applianceDetailsPage,
      navigationRules: [...NAVIGATION_RULES],
    }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    CommonFeatureCoreModule,
    EffectsModule.forRoot([RestartJourneyEffects, QueryParamsEffects]),
    ApplianceDetailsUiModule,
  ],
  providers: [
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },

    {
      provide: APPLIANCE_DETAILS_FORM_DATA_PROVIDER,
      multi: true,
      useClass: ApplianceDetailsQueryParamsFormDataProvider,
    },
    {
      provide: APPLIANCE_DETAILS_FORM_DATA_PROVIDER,
      multi: true,
      useClass: ApplianceDetailsStoreFeatureConfigFormDataProvider,
    },
  ],
  exports: [...modules, HooverAppComponent, ErrorComponent],
})
export class HooverFeatureShellModule {
  static forRoot(
    navigationConfig: AppProvidersConfig
  ): ModuleWithProviders<HooverFeatureShellModule> {
    return {
      ngModule: HooverFeatureShellModule,
      providers: [
        { provide: AppProvidersConfigToken, useValue: navigationConfig },
      ],
    };
  }
}
